import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'react-bootstrap';
import Icons from '../../constants/Icons';
import BuyPoints from './BuyPoints';

const PointsStatus = ({ productId, pointsBalance = 0, paymentOption }) => {
  const { t } = useTranslation();

  const { pathname } = useLocation();

  return (
    <Container className="pt-2">
      <Row>
        <Col xs={12} className="form-title">
          {t('points_status')}
        </Col>
      </Row>
      <Row className="points-status-container">
        <Col xs={6} className="points-info-container">
          <div className="point-image-container">
            <img src={Icons.diamond} className="diamond-img2" alt="diamond" />
          </div>
          <div className="points-count-container">
            <span className="points-count-title">{t('your_points')}</span>
            <span className="points-count">{pointsBalance}</span>
          </div>
        </Col>
        <Col xs={6} className="buy-points-container">
          <BuyPoints
            url={`${pathname}?payment=${paymentOption}&productId=${productId}&navigation=buyPointsDrawer`}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default PointsStatus;
